<template>
    <Modal v-model="visible" :loading="modalLoading" closable mask-closable :title="getTranslation('u114')" width="80">
        <div>
            
            <Row style="margin-bottom:8px;">
                <Col :span="8">
                    <Checkbox v-model="selectAllInvert" @on-change="onSelectAllInvert">{{ getTranslation('b056') }}</Checkbox>
                </Col>
            </Row>
            <CheckboxGroup v-model="selectedKeys">
                <Row>
                    <Col :span="8" v-for="item in listCol" :key="item.key">
                        <Checkbox :label="item.key">{{ item.label }}</Checkbox>
                    </Col>
                </Row>
            </CheckboxGroup>
        </div>
        <div slot="footer">
            <Row type="flex" class="menu-actions">
                <Col flex="1" class="flex-right">
                <Button type="text" @click="cancel" icon="md-close">{{ getTranslation('b182') }}</Button>&nbsp;
                <Button type="primary" @click="ok" icon="md-checkmark">{{ getTranslation('c006') }}</Button>
                </Col>
            </Row>
        </div>
    </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'RecordCol', // 组件名称
    components: {
        
    },
    props: {
        propVisible: Boolean,
    },

    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        listCol :{
          get() { 
            let rs = [{
                key: '1',
                label: this.getTranslation('m008'),
                selected: true
            },
            {
                key: '2',
                label: this.getTranslation('m009'),
                selected: true
            },
            {
                key: '3',
                label: this.getTranslation('m010'),
                selected: true
            },
            {
                key: '4',
                label: this.getTranslation('r024'),
                selected: true
            },
            {
                key: '5',
                label: this.getTranslation('m011'),
                selected: true
            },
            {
                key: '6',
                label: this.getTranslation('m012'),
                selected: true
            },
            {
                key: '7',
                label: this.getTranslation('m013'),
                selected: true
            },
            {
                key: '8',
                label: this.getTranslation('m014'),
                selected: true
            },            
            {
                key: '9',
                label: this.getTranslation('m213'),
                selected: true
            },
            {
                key: '10',
                label: this.getTranslation('r026'),
                selected: true
            },
            {
                key: '11',
                label: this.getTranslation('m016'),
                selected: true
            },
            {
                key: '12',
                label: this.getTranslation('m017'),
                selected: true
            },
             {
                key: '13',
                label: this.getTranslation('m018'),
                selected: true
            }
            

            ];
            return rs;
         },
            set(val) {  this.val = val}  
        } 

    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.getData();
            }
        },
    },
    data() {
        return {
            modalLoading: true,
            mac: '',
            selectedKeys: [],
            // 单一触发的全选/反选
            selectAllInvert: false
        }
    },

    created() {        
        this.init();

    },
    methods: {
        init() {

        },
        getData() {
            try {
                const raw = localStorage.getItem('machine.showCols');
                if (raw) {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed)) {
                        this.selectedKeys = parsed;
                        return;
                    }
                }
            } catch (_) { /* ignore */ }
            this.selectedKeys = this.listCol.filter(c => c.selected).map(c => c.key);
        },
        onSelectAllInvert(checked) {            
            if(checked) {
                this.selectedKeys = this.listCol.map(c => c.key);
            }else {
                this.selectedKeys = [];
            }
        },
        ok() {
            try {
                if (this.selectedKeys.length == 0) {
                    this.$Message.error(this.getTranslation('u115'));
                    return;
                }
                localStorage.setItem('machine.showCols', JSON.stringify(this.selectedKeys));
            } catch (_) { /* ignore */ }
            this.$emit('machine-col-change');
            this.visible = false;
        },
        cancel() {
            this.visible = false;
        }

    },

}



</script>
<style></style>
<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');
</style>